<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">投诉详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form ref="form" :model="data" :rules="rules" label-width="16rem" style="width: 80%">
          <el-row>
            <el-col :span="12">
              <el-form-item label="提交时间" prop="createdate">
                <el-input v-model="data.createdate" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="来源" prop="platform">
                <el-input v-model="data.platform" :disabled="!IsEdit" :formatter="SourceToNameConverter"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态" prop="status">
                <el-input v-model="data.status" :disabled="!IsEdit" :formatter="StatusToNameConverter"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投诉人" prop="name">
                <el-input v-model="data.name" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="phone">
                <el-input v-model="data.phone" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="事发地" prop="address">
                <el-input v-model="data.address" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投诉对象" prop="becomplained">
                <el-input v-model="data.becomplained" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="投诉内容" prop="content">
                <el-input
                  v-model="data.content"
                  :disabled="!IsEdit"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-form-item label="投诉图片">
              <el-upload
                action="#"
                list-type="picture-card"
                :class="{disabled:uploadDisabled}"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :http-request="uploadAvatar"
                :before-upload="beforeAvatarUpload"
                :file-list="fileList"
                :disabled="!showUploadBtn"
              >
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
            <el-form-item label="短视频">
              <el-upload action="#">
                <video v-if="videoList.length != 0"
                  v-for="item in videoList"
                  :src="item.url"
                  class="video-avatar"
                  controls="controls">
                </video>
              </el-upload>
            </el-form-item>
            <el-form-item label="语音">
              <el-upload action="#">
                <audio
                  v-for="item in voiceList"
                  :src="item.url"
                  class="voice-avatar"
                  controls="controls">
                </audio>
              </el-upload>
            </el-form-item>

            <el-row>
              <el-col :span="24">
                <el-form-item label="是否受理">
                  <el-radio-group v-model="isProcess" @change="isProcessChange">
                    <el-radio label="受理" :disabled="processStatus">受理</el-radio>
                    <el-radio label="不予受理" :disabled="processStatus">不予受理</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24" v-show="first">
                <el-form-item label="确认投诉类型">
                  <el-radio-group v-model="isComplaintType">
                    <el-radio
                    v-for="item in ComplaintTypeArr"
                    :label="item.code"
                    :key="item.code"
                    :value="item.code"
                    :disabled="ComplaintTypeStatus"
                    >{{item.value}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" v-show="reason">
                <el-form-item label="不予受理原因">
                  <el-radio-group v-model="isReason">
                    <el-radio
                    v-for=" item in reasonArr"
                    :label="item.code"
                    :key="item.code"
                    :value="item.code"
                    :disabled="IsEdit"
                    >{{item.value}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-col :span="12" v-show="resultText">
              <el-form-item label="结案说明" prop="processcontent">
                <el-input v-model="processcontent" :disabled="processcontentStatus"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="counterclaim" v-show="counterclaim">
            <el-row>
              <el-col :span="23" :offset="1">
                <el-divider></el-divider>
              </el-col>
            </el-row>
            <zj-layout-container>
              <zj-layout-header>
                <div class="listtitle">重诉详情</div>
              </zj-layout-header>
            </zj-layout-container>
            <el-col :span="12">
              <el-form-item label="重诉理由" prop="heavyreasons">
                <el-input v-model="data.heavyreasons" :disabled="!IsEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-row>
              <el-col :span="24">
                <el-form-item label="是否重诉受理">
                  <el-radio-group v-model="isRestateProcess" @change="isRestateProcessChange">
                    <el-radio label="受理" :disabled="restateProcessStatus">受理</el-radio>
                    <el-radio label="不予受理" :disabled="restateProcessStatus">不予受理</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <el-row>
            <el-col :span="12" v-show="resultText1">
              <el-form-item label="重诉结案说明" prop="heavythatend">
                <el-input v-model="heavythatend" :disabled="IsEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width: 134rem">
        <el-button type="primary" @click="saveData()" v-if="!IsEdit">保存</el-button>
        <el-button @click="onBack()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import Apis from "../../../../../../api";
import ZJApp from "../../../../../app";
import permissionsApi from "../../../../../../request/permissionsApi";
import ComplaintApi from "../../../apis/src/ComplaintApi";
const utils = ZJApp.ZJUtils;

export default {
  name: "ComplaintManagerInfo1",
  controller: "UI",
  action: "ComplaintManagerInfo1",
  data() {
    return {
      data: {
        TouristFeedback: 0,
        ComplaintTime: new Date()
      },
      processStatus: false,
      ComplaintTypeStatus: false,
      processcontentStatus: false,
      restateProcessStatus: false,
      uploadDisabled: false,
      fileList: [],
      voiceList: [],
      videoList: [],
      showUploadBtn: false,
      first: false,
      reason: false,
      resultText: false,
      counterclaim: false,
      resultText1: false,
      isProcess: "",
      isComplaintType: "",
      isReason: "",
      isRestateProcess: "",
      ComplaintTypeArr: [],
      reasonArr: [],
      ComplaintSource: "",
      heavythatend: "",
      detailStatus: 0,
      processcontent: "",
      ComplaintSourceArr: [
        { value: 6, label: "电话" },
        { value: 7, label: "其他" }
      ],
      ComplaintSourceArr1: [
        { value: 1, label: "APP" },
        { value: 2, label: "iOS" },
        { value: 3, label: "官网" },
        { value: 4, label: "公众号" },
        { value: 5, label: "小程序" },
        { value: 6, label: "其他" }
      ],
      ComplaintStatus: "",
      ComplaintStatusArr1: [
        { value: 0, label: "待受理" },
        { value: 1, label: "已受理" },
        { value: 2, label: "不予受理" },
        { value: 3, label: "处理完成" },
        { value: 4, label: "重诉待受理" },
        { value: 5, label: "重诉已受理" },
        { value: 6, label: "已完结" }
      ],
      ComplaintSubType: "",
      ComplaintSubTypeArr: [
        { value: 1, label: "景区投诉" },
        { value: 2, label: "环境投诉" },
        { value: 3, label: "服务投诉" },
        { value: 4, label: "物价投诉" },
        { value: 5, label: "其他投诉" }
      ],
      ComplaintDepartmentId: "",
      ComplaintDepartments: [],
      loading: false,
      loadingText: "加载中...",
      EqRegionArr: [],
      IsEdit: false,
      dialogVisible: false,
      rules: {
        TRASHCODE: [
          { required: true, message: "请输入垃圾桶编号", trigger: "blur" }
        ],
        TRASHNAME: [
          { required: true, message: "请输入垃圾桶名称", trigger: "blur" }
        ],
        LONGITUDE: [
          {
            required: true,
            message: "请输入有效的经度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/
          }
        ],
        LATITUDE: [
          {
            required: true,
            message: "请输入有效的纬度",
            trigger: "blur",
            pattern: /^(-?[0-9]+)(\.[0-9]+)?$/
          }
        ],
        BELONGAREA: [
          { required: true, message: "请选择区域", trigger: "change" }
        ],
        TRASHTYPE: [
          { required: true, message: "请选择垃圾桶类型", trigger: "change" }
        ]
      },
      uuid:
        this.$route.query.type == "edit"
          ? this.$route.query.InfoId
          : ZJApp.ZJUtils.uuid()
    };
  },
  created: function() {
    this.bindDatabase();
    if (this.$route.query.InfoId) {
      this.getFileList();
    }
    if (this.$route.query.type == "edit") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  mounted: function() {
    if (this.CNF("app.isBiaoZhunHua")) {
      this.getBJDepartments();
    } else {
      this.getTopDepartments();
    }
  },
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.getFileList();
      }
    }
  },
  computed: {
  },
  methods: {
    isProcessChange(val) {
      console.log(val);
      if (val == "受理") {
        this.first = true;
        this.reason = false;
        this.resultText = false;
      } else {
        this.reason = true;
        this.resultText = true;
        this.first = false;
      }
    },
    isRestateProcessChange(val) {
      if (val == "不予受理") {
        this.resultText1 = true;
      } else {
        this.resultText1 = false;
      }
    },
    // 获取确认投诉类型
    getComplaintType() {
      var formData=new URLSearchParams();
      formData.append('groupCode',"ts_type");
      axios.post(global.$config.api.apiUrl+"/common-api/common/findSDictionaryByGroupCode",formData)
      .then((res) => {
        this.ComplaintTypeArr=res.data.data;  
        })
      .catch((err) => {return err})
    },
    // 获取不予受理原因
    getReason() {
      var formData=new URLSearchParams();
      formData.append('groupCode',"ts_close_reason");
      axios.post(global.$config.api.apiUrl+"/common-api/common/findSDictionaryByGroupCode",formData)
      .then((res) => {
        this.reasonArr=res.data.data;  
        })
      .catch((err) => {return err})
    },
    StatusToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const StatusName = this.ComplaintStatusArr1.map(item => {
        if (item.value == data) return item.label;
      })
      return StatusName;
    },
    SourceToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const SourceName = this.ComplaintSourceArr1.map(item => {
        if (item.ItemValue == data) return item.Description;
      }).join("");
      if (SourceName == null || SourceName == "") {
        return data;
      }
      return SourceName;
    },
    bindDatabase() {
      this.loading = true;
      this.loadingText = "加载中...";
      return utils
        .waitAll([
          this.config.getUValue("ComplaintSubSystem:ComplaintSource:", ""),
          this.config.getUValue("ComplaintSubSystem:ComplaintStatus:", ""),
          this.config.getUValue("ComplaintSubSystem:ComplaintSubType:", "")
        ])
        .then(r => {
          this.ComplaintSourceArr = r[0].JValue;
          this.ComplaintStatusArr = r[1].JValue;
          this.ComplaintSubTypeArr = r[2].JValue;

          this.loading = false;

          return r;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    //北京统一登录时获取北京所有部门
    getBJDepartments() {
      const that = this;
      console.log(this.$route.query);
      ComplaintApi.GetSuggestDetailForm({
        "id": this.$route.query.Info.id
      }).then(res => {
        let data = res.data;
        this.detailStatus = data.status;
        if (data.status == 1) {
          that.isProcess = '受理';
          that.first = true;
          that.isComplaintType = data.resulttype;
          that.resultText = true;
          that.processStatus = true;
          that.ComplaintTypeStatus = true;
        } else if (data.status == 2) {
          this.isProcess = "不予受理";
          that.reason = true;
          that.resultText = true;
        } else if (data.status == 3) {
          that.resultText = true;
          that.first = true;
          that.isProcess = '受理';
          that.isComplaintType = data.resulttype;
          that.processcontent = data.processcontent;
          that.processStatus = true;
          that.ComplaintTypeStatus = true;
          that.processcontentStatus = true;
        } else if (data.status == 4) {
          that.isProcess = '受理';
          that.counterclaim = true;
          that.resultText = true;
          that.first = true;
          that.isComplaintType = data.resulttype;
          that.processcontent = data.processcontent;
          that.processStatus = true;
          that.ComplaintTypeStatus = true;
          that.processcontentStatus = true;
        } else if (data.status == 5) {
          that.isProcess = '受理';
          that.counterclaim = true;
          that.resultText = true;
          that.first = true;
          that.isComplaintType = data.resulttype;
          that.isRestateProcess = '受理';
          that.resultText1 = true;
          that.processcontent = data.processcontent;
          that.processStatus = true;
          that.ComplaintTypeStatus = true;
          that.processcontentStatus = true;
          that.restateProcessStatus = true;
        } else if (data.status == 6) {
          that.reason == true;
          that.resultText == true;
          that.processStatus = true;
          that.ComplaintTypeStatus = true;
          that.processcontentStatus = true;
          if (data.isheavy == 1) {
              that.isProcess = "受理";
              that.first = true;
              that.isComplaintType = data.resulttype;
              that.resultText = true;
              that.counterclaim = true;
              that.isRestateProcess = "不予受理";
              that.heavythatend = data.heavythatend;
              that.resultText1 = true;
              if (data.isacceptheavy == 1) {
                that.isRestateProcess = "受理";
              } else {
                that.isRestateProcess = "不予受理";
              }
          } else {
              if (['1','2','3'].includes(data.resulttype)) {
                that.isProcess = "受理";
                that.first = true;
                that.isComplaintType = data.resulttype;
                that.resultText = true;
              } else {
                that.isProcess = "不予受理";
                that.reason = true;
                that.isReason = data.noprocessingreason;
                that.resultText = true;
              }
              that.processStatus = true;
          }
        }

        let SuggestDetailArray = [];
        SuggestDetailArray.push(res.data)
        SuggestDetailArray.map(item => {
          that.ComplaintSourceArr1.map(el => {
            if (item.platform == el.value) {
              item.platform = el.label;
            }
          })
          that.ComplaintStatusArr1.map(el => {
            if (item.status == el.value) {
              item.status = el.label;
            }
          })
          if (item.productimages) {
            let imgList = [];
            imgList = item.productimages.split(",");
            imgList.map(item => {
              const url = item;
              let obj = {
                url
            }
            that.fileList.push(obj);
            })
          }
          if(item.video) {
            let vList = [];
            vList = item.video.split(",");
            vList.map(item => {
              const url = item;
              let videoObj = {
                url
              }
            that.videoList.push(videoObj);
            })
          }
          
          if(item.voices) {
            item.voices.map(item => {
            const url = item.pathurl;
            let voiceObj = {
              url
            }
            that.voiceList.push(voiceObj);
            })
          }
        })
        that.data = res.data;

        this.getComplaintType();
        this.getReason();
      }).catch(err => {
        console.log(err);
      })
      // permissionsApi
      //   .findOrganizationTree({ projectCode: this.CNF("app.perProjectCode") })
      //   .then(res => {
      //     if (res.code == 0) {
      //       if (res.data.length > 0) {
      //         const departs = this.flattenTree(res.data);

      //         this.ComplaintDepartments = departs.map(item => {
      //           return { OrgId: item.code, OrgName: item.name };
      //         });
      //       }
      //     } else {
      //       this.errmsg(res.msg);
      //     }
      //   });
    },
    flattenTree(nodes) {
      var r = [];
      if (Array.isArray(nodes)) {
        for (var i = 0, l = nodes.length; i < l; i++) {
          r.push(nodes[i]); // 取每项数据放入一个新数组
          if (
            Array.isArray(nodes[i]["children"]) &&
            nodes[i]["children"].length > 0
          )
            // 若存在children则递归调用，把数据拼接到新数组中，并且删除该children
            r = r.concat(this.flattenTree(nodes[i]["children"]));
          delete nodes[i]["children"];
        }
      }
      return r;
    },
    //绑定部门信息
    getTopDepartments() {
      new Apis.OrgApi()
        .FindByConditions({ OrgCode: this.config.app.org_code })
        .then(r => {
          r = r.data.Data;
          if (r != null && r.length > 0) {
            this.getDepartments(r[0].OrgId);
          }
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    getDepartments(OrgId) {
      new Apis.OrgApi()
        .FindByConditions({ ParentOrgId: OrgId })
        .then(r => {
          r = r.data.Data;
          this.ComplaintDepartments = r;
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //保存
    saveData() {
      if(this.isProcess==""){
        this.$message({
          type: "warning",
          message: "请选择是否受理"
        });
        return
      }
      var param = {
          id:this.$route.query.Info.id,
          type:1
      },msg = "受理";
      if (this.detailStatus == 0 && this.isProcess == '受理') {
        param.status = 1;//已受理
        param.resulttype = this.isComplaintType;
        param.isaccept = 1;
        if (this.isComplaintType == "") {
          this.$message({
            type: "warning",
            message: "请选择初判投诉类型"
          });
          return
        }
      } else if(this.detailStatus == 0&&this.isProcess=='不予受理'){
        param.status = 6;//不予受理
        param.isaccept = 0;
        param.processcontent = this.processcontent;//处理结果
        param.noprocessingreason= this.isReason; //依据数据字典选择
        param.heavythatend= this.processcontent;  //处理结果
        if (this.isReason == "") {
          this.$message({
            type: "warning",
            message: "请选择不予受理原因"
          });
          return
        }
        if (this.processcontent == "") {
          this.$message({
            type: "warning",
            message: "请输入结案说明"
          });
          return
        }
        msg = '结案'
      } else if(this.detailStatus==1){
        if (this.processcontent == "") {
          this.$message({
            type: "warning",
            message: "请输入结案说明"
          });
          return
        }
        param.status = 3;
        param.processcontent = this.processcontent; //处理结果
        param.resulttype = this.isComplaintType;
        msg = '结案'
      } else if(this.detailStatus==4 &&this.isRestateProcess=='受理'){
        param.status = 5;
        param.isacceptheavy = 1;
        msg = '重诉受理';
      } else if(this.detailStatus==4 &&this.isRestateProcess=='不予受理'){
        if (this.heavythatend == "") {
          this.$message({
            type: "warning",
            message: "请输入重诉结案说明"
          });
          return
        }
        param.status = 6;
        param.isacceptheavy = 0;
        param.heavythatend = this.heavythatend; //处理结果
        msg = '结案'
      } else if(this.detailStatus==5){
        if (this.heavythatend == "") {
          this.$message({
            type: "warning",
            message: "请输入重诉结案说明"
          });
          return
        }
        param.status = 6;
        param.heavythatend = this.heavythatend; //处理结果
        msg = '结案';
      }
      this.loading = true;
      this.loadingText = "保存中...";
      ComplaintApi.SuggestUpdate(JSON.stringify(param))
      .then(res => {
        if(res.code == 0) {
          this.$message({
            type: "success",
            message: msg + "成功"
          });
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
        this.loading = false;
        this.$router.go(-1);
      }).catch(err => {
        this.loading = false;
        this.$message.error(err);
      })
    }
  }
};
</script>
<style scoped>
  ::v-deep .el-upload--picture-card {
    display: none !important;
  }
  .video-avatar {
    width: 146px;
    height: 146px;
  }
  .voice-avatar {
    display: block;
    margin-bottom: 10px;
  }
</style>
